import angular from 'angular';

import PulseIndicatorComponent from './pulse-indicator.cmpt';

export default angular
    .module('common.component.loader.component.pulse-indicator', [])
    .component(PulseIndicatorComponent.selector, PulseIndicatorComponent);



// WEBPACK FOOTER //
// ./src/common/component/loader/component/pulse-indicator/index.js